/* ============================================================================= */
/* Ella Custom JS - Customize The Style For Layout */
/* ============================================================================= */

/* ============================================================================= */
/* IMPORTANT DISCLAIMER */
/* Please use only JS to style the layout. */
/* ============================================================================= */

(function () {
  /*
    Spinto Smelling Salts — no quantity option, pack size only.
    ------------------------------------------------------------
    This product (gid://shopify/Product/10154709516581) sells each
    pack size as its own variant (1/2/3/4/6 Bottles), each with its own
    correct price set directly on the variant:
      1 Bottle   -> $19.99
      2 Bottles  -> $37.98
      3 Bottles  -> $53.97
      4 Bottles  -> $67.97
      6 Bottles  -> $95.98
    There is no separate "quantity" concept for this product — a shopper
    should only ever change how many bottles they get by picking a
    different pack (variant) on the product page, never by bumping the
    quantity number on the cart page.

    This locks every cart line for one of these 5 variants to quantity 1.
    If quantity is ever pushed above 1 (typo, stray click, browser back
    button, etc.), it's reverted back to 1 automatically — so it's never
    possible to end up with a mismatched price like 2 x "1 Bottle"
    ($39.98) silently standing in for the real "2 Bottles" bundle
    ($37.98).

    Scope: this script only ever touches cart lines whose variant_id is
    one of the 5 IDs below. Every other product on the store is
    completely unaffected.
  */
  var LOCKED_VARIANT_IDS = [
    52929374880037, // 1 Bottle — $19.99
    52929374912805, // 2 Bottles — $37.98
    52929374945573, // 3 Bottles — $53.97
    52929374978341, // 4 Bottles — $67.97
    52929375011109  // 6 Bottles — $95.98
  ];

  var fixing = false;

  function enforceQuantityLock() {
    if (fixing) return;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var offender = null;
        for (var i = 0; i < cart.items.length; i++) {
          if (LOCKED_VARIANT_IDS.indexOf(cart.items[i].variant_id) !== -1 && cart.items[i].quantity !== 1) {
            offender = cart.items[i];
            break;
          }
        }
        if (!offender) return;

        fixing = true;
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: offender.key, quantity: 1 })
        })
          .then(function () {
            window.location.reload();
          })
          .catch(function () {
            fixing = false;
          });
      })
      .catch(function () {});
  }

  var _fetch = window.fetch;
  window.fetch = function () {
    var args = arguments;
    var url = args[0] && args[0].url ? args[0].url : args[0];
    var isCartMutation = typeof url === 'string' && (
      url.indexOf('/cart/change') !== -1 ||
      url.indexOf('/cart/update') !== -1 ||
      url.indexOf('/cart/add') !== -1
    );
    return _fetch.apply(window, args).then(function (response) {
      if (isCartMutation && !fixing) {
        setTimeout(enforceQuantityLock, 200);
      }
      return response;
    });
  };

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form && form.action && form.action.indexOf('/cart') !== -1) {
      setTimeout(enforceQuantityLock, 500);
    }
  });

  if (window.location.pathname.indexOf('/cart') !== -1) {
    document.addEventListener('DOMContentLoaded', enforceQuantityLock);
    if (document.readyState !== 'loading') enforceQuantityLock();
  }
})();

/* ============================================================================= */
/* Spinto Smelling Salts — per-bottle savings + badges on the pack picker.      */
/*                                                                              */
/* Shows, under each pack size:                                                */
/*   [optional badge: MOST POPULAR / 🔥 BEST VALUE]                            */
/*   Save $X • $X.XX/bottle                                                    */
/*                                                                              */
/* SINGLE SOURCE OF TRUTH: "Save $X" is the real Shopify compare-at price      */
/* minus the real selling price for that variant (the actual markdown you've   */
/* set in Shopify Admin — Product > Pricing > Compare-at price), fetched live  */
/* from the storefront AJAX API. "$X.XX/bottle" is the real selling price      */
/* divided by the bottle count. Nothing here is a hardcoded/guessed number —   */
/* if you change a price or compare-at price in Shopify Admin, this text       */
/* updates automatically on next page load.                                   */
/*                                                                              */
/* Scope: only runs when it finds one of the 5 locked Smelling Salts variant   */
/* IDs on the page (via the native picker's data-variant-id attributes), so    */
/* every other product on the store is completely unaffected.                 */
/* ============================================================================= */
(function () {
  // variantId -> { count: bottles in this pack, badge: label shown above the
  // savings line (null = no badge) }
  var VARIANT_META = {
    52929374880037: { count: 1, badge: null },               // 1 Bottle
    52929374912805: { count: 2, badge: 'MOST POPULAR' },     // 2 Bottles
    52929374945573: { count: 3, badge: null },                // 3 Bottles
    52929374978341: { count: 4, badge: null },                // 4 Bottles
    52929375011109: { count: 6, badge: '🔥 BEST VALUE' } // 6 Bottles
  };
  var LOCKED_VARIANT_IDS = Object.keys(VARIANT_META).map(function (k) { return parseInt(k, 10); });

  function formatMoney(n) {
    return '$' + n.toFixed(2);
  }

  function findPickerRoot() {
    return document.querySelector('variant-radios[data-url], variant-selects[data-url]');
  }

  function render(variants) {
    var byId = {};
    for (var i = 0; i < variants.length; i++) {
      byId[variants[i].id] = variants[i];
    }

    var labels = document.querySelectorAll('label[data-variant-id]');
    for (var i2 = 0; i2 < labels.length; i2++) {
      var label = labels[i2];
      var vid = parseInt(label.getAttribute('data-variant-id'), 10);
      var meta = VARIANT_META[vid];
      if (!meta) continue;
      if (label.querySelector('.ss-savings-wrap')) continue; // already injected

      var variant = byId[vid];
      if (!variant) continue;

      var price = variant.price / 100; // AJAX API returns cents
      var compareAt = variant.compare_at_price ? variant.compare_at_price / 100 : null;
      var perBottle = price / meta.count;

      var wrap = document.createElement('span');
      wrap.className = 'ss-savings-wrap';
      wrap.style.cssText = 'display:block;margin-top:4px;';

      if (meta.badge) {
        var badge = document.createElement('span');
        badge.className = 'ss-badge';
        badge.style.cssText = 'display:inline-block;background:#fff1e6;color:#c2410c;padding:2px 8px;border-radius:999px;font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:.03em;margin-bottom:3px;';
        badge.textContent = meta.badge;
        wrap.appendChild(badge);
      }

      if (compareAt && compareAt > price) {
        var savingsLine = document.createElement('span');
        savingsLine.className = 'ss-savings';
        savingsLine.style.cssText = 'display:block;font-size:12px;line-height:1.3;font-weight:600;color:#1a7a3c;';
        var savingsTotal = Math.round(compareAt - price);
        savingsLine.textContent = 'Save $' + savingsTotal + ' • ' + formatMoney(perBottle) + '/bottle';
        wrap.appendChild(savingsLine);
      }

      if (wrap.childNodes.length) {
        label.appendChild(wrap);
      }
    }
  }

  function init() {
    var root = findPickerRoot();
    if (!root) return;

    var labels = document.querySelectorAll('label[data-variant-id]');
    var isSmellingSalts = false;
    for (var i = 0; i < labels.length; i++) {
      var lid = parseInt(labels[i].getAttribute('data-variant-id'), 10);
      if (LOCKED_VARIANT_IDS.indexOf(lid) !== -1) {
        isSmellingSalts = true;
        break;
      }
    }
    if (!isSmellingSalts) return;

    var url = root.getAttribute('data-url');
    if (!url) return;

    fetch(url + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (productJson) {
        if (productJson && productJson.variants) render(productJson.variants);
      })
      .catch(function () {});
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
